// @ts-nocheck
import React, { useState } from "react";
import SharedSelect from "./SharedSelect";
import "../styles/ReportUserModal.css";
import { reportUser } from "../api/moderation";
import { getUser } from "../auth/auth";
import { useToast } from "./ToastProvider";

export default function ReportUserModal({ targetUserId, targetUserName, onClose, prefillReason, prefillDetails }) {
  const { showToast } = useToast();
  const [reason, setReason] = useState(prefillReason || "scam");
  const [details, setDetails] = useState(prefillDetails || "");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const currentUser = getUser();
      await reportUser(currentUser.id, targetUserId, reason, details);
      setSubmitted(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error) {
      showToast(error.message || "Failed to submit report", "error");
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content report-modal" onClick={(e) => e.stopPropagation()}>
          <div className="report-success">
            <div className="success-icon">✓</div>
            <h3>Report Submitted</h3>
            <p>Thank you for helping keep Cardex safe. Our team will review this report.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content report-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Report User</h2>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="modal-body">
          <p className="report-target">
            You are reporting: <strong>{targetUserName}</strong>
          </p>

          <form onSubmit={handleSubmit}>
            <label className="form-label">Reason for Report</label>
            <SharedSelect
              className="form-select"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
            >
              <option value="scam">Scam / Fraud</option>
              <option value="harassment">Harassment</option>
              <option value="counterfeit">Counterfeit Activity</option>
              <option value="inappropriate">Inappropriate Content</option>
              <option value="other">Other</option>
            </SharedSelect>

            <label className="form-label">Additional Details</label>
            <textarea
              className="form-textarea"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              placeholder="Describe the issue in detail..."
              rows={5}
              required
            />

            <div className="report-notice">
              ⚠️ False reports may result in action against your account
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="btn-cancel"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? "Submitting..." : "Submit Report"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
